// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as ReasonReactUpdate from "../../../../vendored/reason-react-update/ReasonReactUpdate.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";

function sumAmount(items) {
  return Belt__Belt_List.reduce(items, 0, (function (sum, item) {
                return sum + item.total_amount;
              }));
}

function useForm(onTransitionOpt, onStartOverOpt, onSubmit, initialState) {
  const onTransition = onTransitionOpt !== undefined ? onTransitionOpt : (function (param) {
        
      });
  const onStartOver = onStartOverOpt !== undefined ? onStartOverOpt : (function (param) {
        
      });
  const formSubmitHandler = function (type_, param) {
    const send = param.send;
    const __x = Curry._1(onSubmit, param.state);
    $$Promise.get(__x, (function (result) {
            if (result.TAG === /* Ok */0) {
              return Curry._1(send, {
                          TAG: /* TransitionTo */0,
                          _0: {
                            TAG: /* Receipt */1,
                            _0: result._0
                          }
                        });
            }
            const err = result._0;
            Curry._1(send, {
                  TAG: /* TransitionTo */0,
                  _0: {
                    TAG: /* Payment */0,
                    _0: {
                      TAG: /* Error */1,
                      _0: err
                    }
                  }
                });
            console.log("api error", err);
          }));
    Curry._1(send, {
          TAG: /* TransitionTo */0,
          _0: {
            TAG: /* Payment */0,
            _0: {
              TAG: /* Submitting */0,
              _0: type_
            }
          }
        });
  };
  return ReasonReactUpdate.useReducerWithMapState(initialState, (function (action, state) {
                if (typeof action === "number") {
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: Curry._1(initialState, undefined),
                          _1: (function (param) {
                              Curry._1(onStartOver, undefined);
                            })
                        };
                }
                switch (action.TAG | 0) {
                  case /* TransitionTo */0 :
                      const stage = action._0;
                      return {
                              TAG: /* SideEffects */2,
                              _0: (function (param) {
                                  Curry._1(onTransition, stage);
                                })
                            };
                  case /* AddItem */1 :
                      const items = Stdlib.$at(state.items, {
                            hd: action._0,
                            tl: /* [] */0
                          });
                      const totalAmount = sumAmount(items);
                      return {
                              TAG: /* Update */0,
                              _0: {
                                operation_type: state.operation_type,
                                items: items,
                                payments: state.payments,
                                total_amount: totalAmount,
                                taken: state.taken,
                                change: state.change
                              }
                            };
                  case /* UpdateItem */2 :
                      const index = action._1;
                      const new_item = action._0;
                      const items$1 = Belt__Belt_List.mapWithIndex(state.items, (function (i, item) {
                              if (i === index) {
                                return new_item;
                              } else {
                                return item;
                              }
                            }));
                      const totalAmount$1 = sumAmount(items$1);
                      return {
                              TAG: /* Update */0,
                              _0: {
                                operation_type: state.operation_type,
                                items: items$1,
                                payments: state.payments,
                                total_amount: totalAmount$1,
                                taken: state.taken,
                                change: state.change
                              }
                            };
                  case /* DeleteItem */3 :
                      const index$1 = action._0;
                      const items$2 = Belt__Belt_List.keepWithIndex(state.items, (function (param, i) {
                              return i !== index$1;
                            }));
                      const totalAmount$2 = sumAmount(items$2);
                      return {
                              TAG: /* Update */0,
                              _0: {
                                operation_type: state.operation_type,
                                items: items$2,
                                payments: state.payments,
                                total_amount: totalAmount$2,
                                taken: state.taken,
                                change: state.change
                              }
                            };
                  case /* DeleteAll */4 :
                      const items$3 = action._0;
                      const items$4 = Belt__Belt_List.keepWithIndex(state.items, (function (param, i) {
                              return !Stdlib__List.exists((function (idx) {
                                            return idx === i;
                                          }), items$3);
                            }));
                      const totalAmount$3 = sumAmount(items$4);
                      return {
                              TAG: /* Update */0,
                              _0: {
                                operation_type: state.operation_type,
                                items: items$4,
                                payments: state.payments,
                                total_amount: totalAmount$3,
                                taken: state.taken,
                                change: state.change
                              }
                            };
                  case /* AddPayment */5 :
                      const payments = Stdlib.$at(state.payments, {
                            hd: action._0,
                            tl: /* [] */0
                          });
                      const __x = Belt__Belt_List.keep(payments, (function (p) {
                              return p.payment_type === /* PAYMENT_TYPE_CASH */1;
                            }));
                      const taken = Belt__Belt_List.reduce(__x, 0, (function (sum, payment) {
                              return sum + payment.amount;
                            }));
                      const change = state.total_amount - taken;
                      return {
                              TAG: /* Update */0,
                              _0: {
                                operation_type: state.operation_type,
                                items: state.items,
                                payments: payments,
                                total_amount: state.total_amount,
                                taken: taken,
                                change: change
                              }
                            };
                  case /* SubmitWithPayment */6 :
                      const payments_0 = action._0;
                      const payments$1 = {
                        hd: payments_0,
                        tl: /* [] */0
                      };
                      const __x$1 = Belt__Belt_List.keep(payments$1, (function (p) {
                              return p.payment_type === /* PAYMENT_TYPE_CASH */1;
                            }));
                      const taken$1 = Belt__Belt_List.reduce(__x$1, 0, (function (sum, payment) {
                              return sum + payment.amount;
                            }));
                      const change$1 = state.total_amount - taken$1;
                      return {
                              TAG: /* UpdateWithSideEffects */1,
                              _0: {
                                operation_type: state.operation_type,
                                items: state.items,
                                payments: payments$1,
                                total_amount: state.total_amount,
                                taken: taken$1,
                                change: change$1
                              },
                              _1: (function (param) {
                                  return formSubmitHandler(/* Full */0, param);
                                })
                            };
                  case /* SubmitWithSplitPayment */7 :
                      const payments$2 = Stdlib.$at(state.payments, action._0);
                      const __x$2 = Belt__Belt_List.keep(payments$2, (function (p) {
                              return p.payment_type === /* PAYMENT_TYPE_CASH */1;
                            }));
                      const taken$2 = Belt__Belt_List.reduce(__x$2, 0, (function (sum, payment) {
                              return sum + payment.amount;
                            }));
                      const change$2 = state.total_amount - taken$2;
                      return {
                              TAG: /* UpdateWithSideEffects */1,
                              _0: {
                                operation_type: state.operation_type,
                                items: state.items,
                                payments: payments$2,
                                total_amount: state.total_amount,
                                taken: taken$2,
                                change: change$2
                              },
                              _1: (function (param) {
                                  return formSubmitHandler(/* Split */1, param);
                                })
                            };
                  
                }
              }));
}

export {
  sumAmount ,
  useForm ,
}
/* Promise Not a pure module */
